import {
  HubConnectionBuilder,
  LogLevel,
  HubConnectionState,
} from "@microsoft/signalr";
import { toast } from "react-toastify";
import store from "./../../store.js";
import { triggerReload } from "./../../reduxadmin/Actions/index.js";

let activeConnection = null;
let reloadTimeout;

export const connectSignalR = async (
  setConn,
  showToastMessage,
  countNotification,
  setNotification,
  flag,
  setFlag,
  setConnectionStatus // optional
) => {
  //   if (activeConnection && activeConnection.state !== "Disconnected") {
  //     console.log("⚠️ Reusing existing SignalR connection");
  //     // setConn(activeConnection);
  //     return;
  //   }
  try {
    console.log("Connecting to SignalR...");

    const connection = new HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_SECRET}/SignalR-hub`)
      .configureLogging(LogLevel.Information)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) =>
          Math.min(1000 * (retryContext.previousRetryCount + 1), 10000),
      })
      .build();

    activeConnection = connection;
    // ---------------- Event Handlers ----------------
    connection.on("GetNotificationForSuperAdmin", (message) => {
      if (message && !flag) {
        showToastMessage(message.notificationMessage);
        setNotification(message.notificationMessage);
        countNotification();
        setFlag(true);
      }
    });

    connection.on("NewChat", (message) => {
      console.log("NewChat:", message);
    });

    let reloadTimeout;

    connection.on("UpdateQueue", (message) => {
      console.log("UpdateQueue:", message);
      localStorage.setItem("loadQueue", "Load");

      clearTimeout(reloadTimeout);
      store.dispatch(triggerReload());
    });

    connection.on("GetNotification", (message) => {
      console.log("GetNotification:", message);
    });

    // ---------------- Helper: join restaurant group ----------------
    const joinRestaurantGroup = async () => {
      const restaurantData = localStorage.getItem("restaurant");
      if (restaurantData) {
        const restaurantObj = JSON.parse(restaurantData);
        const restaurantId = restaurantObj?.id;
        if (restaurantId) {
          try {
            console.log("Joining restaurant group:", restaurantId);
            await connection.invoke(
              "NewConnectionToGroupWithMethodName",
              restaurantId,
              "UpdateQueue"
            );
          } catch (err) {
            console.warn("Group join failed:", err);
          }
        }
      }
    };

    // ---------------- Helper: start connection ----------------
    const startConnection = async () => {
      if (
        connection.state === HubConnectionState.Disconnected ||
        connection.state === HubConnectionState.Disconnecting
      ) {
        try {
          setConnectionStatus?.("Connecting...");
          await connection.start();
          console.log("✅ SignalR connected.");
          setConnectionStatus?.("Connected");

          await connection.invoke("NewConnectionToGroup", "SuperAdmin");
          await joinRestaurantGroup();
        } catch (err) {
          console.error("❌ SignalR start failed:", err);
          setConnectionStatus?.("Connection failed");
          setTimeout(startConnection, 5000); // retry in 5s
        }
      }
    };

    // ---------------- Initial connection ----------------
    await startConnection();

    // Rejoin restaurant group when it becomes available
    const restaurantCheckInterval = setInterval(() => {
      if (localStorage.getItem("restaurant")) {
        joinRestaurantGroup();
        clearInterval(restaurantCheckInterval);
      }
    }, 2000);

    setConn(connection);

    // ---------------- Handle reconnection ----------------
    connection.onreconnecting(() => {
      console.warn("SignalR reconnecting...");
      setConnectionStatus?.("Reconnecting...");
    });

    connection.onreconnected(async () => {
      console.log("ignalR reconnected.");
      toast.success("Reconnected to server.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        toastId: "reconnected",
      });
      try {
        await connection.invoke("NewConnectionToGroup", "SuperAdmin");
        await joinRestaurantGroup();
      } catch (err) {
        console.error("Rejoin after reconnect failed:", err);
      }
      setConnectionStatus?.("Connected");
    });

    connection.onclose(async () => {
      console.warn("SignalR closed. Retrying...");
      setConnectionStatus?.("Disconnected");
      await startConnection();
    });

    // ---------------- Handle Sleep/Wake ----------------
    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        console.log("App/tab is visible. Checking SignalR...");
        try {
          await startConnection();
        } catch (err) {
          console.error("Failed to reconnect after wake:", err);
        }
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // ---------------- Handle Network Loss/Recovery ----------------
    const handleOnline = async () => {
      console.log("Network online. Checking SignalR...");
      setConnectionStatus?.("Online");
      await startConnection();
    };
    const handleOffline = () => {
      console.warn("Network offline. Waiting for reconnection...");
      setConnectionStatus?.("Offline");
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // ---------------- Periodic Health Check ----------------
    const healthCheck = setInterval(async () => {
      if (
        navigator.onLine &&
        (connection.state === HubConnectionState.Disconnected ||
          connection.state === HubConnectionState.Disconnecting)
      ) {
        console.log("Health check triggered: reconnecting SignalR...");
        await startConnection();
      }
    }, 30000);

    // ---------------- Cleanup ----------------
    return () => {
      clearInterval(restaurantCheckInterval);
      clearInterval(healthCheck);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      if (connection) {
        connection.stop();
        console.log("SignalR stopped and cleaned up.");
      }
    };
  } catch (error) {
    console.error("SignalR fatal error:", error);
  }
};
